import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, NgZone } from '@angular/core';
import { LayoutService } from '../layout/layout.service';
import { BrandAllocation } from '../../client-core/dtos/brand-allocation.models';
import { BrandService } from '../../client-core/services/brand.service';
import { ValidationMessage } from 'app/validation';
import { ChangeDriver, ChangeIndicator } from 'app/client-core/dtos/change-driver.model';
import { CommunicationRequestDto, NewCommunicationRequestDto } from '../../client-core/dtos/communication-request.model';
import { Observable } from 'rxjs';
import { ProgramService } from 'app/client-core/services/program.service';
import { DropzoneComponent, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ApiService } from 'app/client-core/api.service';
import * as moment from 'moment';
import { NotificationService } from '../utils/notification.service';
const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  maxFilesize: 50,
  acceptedFiles: '*'
};

@Component({
  selector: 'new-communication-request',
  templateUrl: './new-communication-request.component.html',
  styleUrls: ['./new-communication-request.component.scss']
})
export class NewCommunicationRequestComponent implements OnInit, OnChanges {
  @Input() requestId: number;
  @ViewChild('drpzone') drpzone: DropzoneComponent;
  ready: boolean;
  validationMessages: any;
  dto: CommunicationRequestDto = {} as CommunicationRequestDto;
  submitted: boolean;
  items: any[] = [];
  contactitems: any[] = [];
  files: any[] = [];
  columns = Observable.of([
    { prop: "id", name: "Id", flexGrow: 1 },
    { prop: "name", name: "Name", flexGrow: 3 },
  ]);
  config: any;
  currentDate=moment().toDate();
  saving: boolean;

  constructor(
    private layoutService: LayoutService,
    public programService: ProgramService,
    private zone: NgZone,
    private apiService: ApiService,
    private notificationService: NotificationService
  ) {
    const self = this;
    this.config = {
      autoProcessQueue: false,
      acceptedFiles: '*',
      uploadMultiple: true,
      addRemoveLinks: true,
      dictDefaultMessage: 'Click or drop files here',
      init: function() {
        var drop = this;
        this.on('addedfile', function(file) {
          self.zone.run(() => {
            console.log(file);
            self.files.push(file);
            console.log(self.files);
          })
        });

        this.on('removedfile', function(file) {
          self.zone.run(() => {
            self.files = drop.files;
            console.log(self.files);
          })
        });
      }
    };
  }

  ngOnInit(): void {
    this.ready = true;
  }

  onUploadSuccess() {

  }

  onUploadError() {

  }

  getReasonforReview() {
    const params = {}
    if (this.requestId) {
      params['requestId'] = this.requestId;
    }
    this.programService.getReasonsForReview(params).subscribe(res => {
      if (res.data && !res.hasError) {
        this.dto.reasonForReview = res.data;
      }
    });
  }

  getRelatedTactics() {
    const params = {
      programId: this.dto.programId
    }
    if (this.requestId) {
      params['requestId'] = this.requestId;
    }
    this.programService.getRelatedPrograms(params).subscribe(res => {
      if (res.data && !res.hasError) {
        this.dto.relatedTactics = res.data;
      } else {
        this.dto.relatedTactics = null;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    
  }

  closeModal() {
    this.dto = new CommunicationRequestDto();
    this.contactitems = [];
    this.items = [];
    this.files = [];
    this.submitted = false;
    this.drpzone.directiveRef.reset();
    this.layoutService.hideSideModal.next();
  }

  isProgramValid() {
    if (!this.dto.programId) {
      return false;
    }
    return true;
  }

  isRequestNameValid() {
    if (!this.dto.requestName) {
      return false;
    }
    return true;
  }

  isAssetDueDateValid() {
    if (!this.dto.assetDueDate) {
      return false;
    }
    return true;
  }

  isReviewDateValid() {
    if (!this.dto.reviewByDate) {
      return false;
    }
    return true;
  }

  isReasonForReviewValid() {
    if(!this.dto.reasonForReview || this.dto.reasonForReview.length == 0) {
      return true;
    }
    if (this.dto.reasonForReview.filter(r => r.selected).length == 0) {
      return false;
    }
    return true;
  }

  isRelatedTacticsValid() {
    if(!this.dto.relatedTactics || this.dto.relatedTactics.length == 0) {
      return true;
    }
    if (this.dto.relatedTactics.filter(r => r.selected).length == 0) {
      return false;
    }
    return true;
  }

  isToValid() {
    return this.contactitems && this.contactitems.length > 0;
  }

  isBodySizeValid() {
    if (!this.dto.messageToBrandTeams) {
        return false;
    }
    return this.dto.messageToBrandTeams.length < 2000;
  }

  onProgramSelected(event): void {
    if (event && event.id) {
      this.dto.programId = event.id;
      this.dto.programName = event.name;
      this.getRelatedTactics();
    }
  }

  canSubmit() {
    return this.isProgramValid() &&
    this.isReasonForReviewValid() &&
    this.isRelatedTacticsValid() &&
    this.isAssetDueDateValid() &&
    this.isToValid() &&
    this.isBodySizeValid()
  }

  onSubmit() {
    this.submitted = false;
    this.saving = true;
    if (!this.canSubmit()) {
      this.validationMessages = new ValidationMessage(null, true, "There are some validation errors.");
      this.submitted = true;
      this.saving = false;
      return;
    }

    if (!this.files || this.files.length == 0) {
      this.notificationService.smartMessageBox({
        title: "",
        content: `You have not upload any files, are you sure you would like to continue?`,
        buttons: '[No][Yes]'
  
      }, (ButtonPressed) => {
          if (ButtonPressed == "Yes") {
            this.saveCommunicationRequest()
          } else {
            this.saving = false;
            this.submitted = false;
            return;
          }
      });
    } else {
      this.saveCommunicationRequest();
    }
  }

  saveCommunicationRequest() {
    const request = {
      programId: this.dto.programId,
      contactIds: this.contactitems.map(c => c.id).join(','),
      dueDate: this.dto.assetDueDate.toISOString(),
      message: this.dto.messageToBrandTeams,
      reasonForReviewIds: this.dto.reasonForReview ? this.dto.reasonForReview.filter(r => r.selected).map(r => r.id).join(',') : '',
      relatedTacticIds: this.dto.relatedTactics ? this.dto.relatedTactics.filter(r => r.selected).map(r => r.id).join(',') : '',
      requestName: this.dto.requestName,
      reviewByDate: this.dto.reviewByDate
    } as NewCommunicationRequestDto;

    if (this.files) {
      request.fileNames = this.files.map(f => f.name).join(',');
    }

    this.programService.saveNewCommunicationRequest(request).subscribe(res => {
      let promisses = [];
      this.files.forEach(file => {
        promisses.push(this.apiService.uploadCommunicationRequestFile(file, this.dto.programId, res.data));
      });
      Promise.all(promisses).then(filesRes => {
        this.validationMessages = new ValidationMessage(null, true, "New communication request submitted.").isSuccess();
        this.saving = false;
        this.closeModal();
      }).catch(error => {
        this.saving = false;
        this.validationMessages = new ValidationMessage(null, true, "There was an error saving your files.").isDanger();
        this.closeModal();
      });
    });
  }

  contactsRowSelected(event) {
    if (this.contactitems && !this.contactitems.find(c => c.id == event.item.id)) {
      this.contactitems.push(event.item);
    }
  }

  contactsRemoveRowSelected(event) {
    this.contactitems = this.contactitems.filter(c => c.id != event.id);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/new-communication-request/new-communication-request.component.ts